import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useQuery } from '../utils/useQuery';

export const SEOHome = ({ data }) => {
	let query = useQuery();

	const resultsChosen = [];
	const resultsArray = data.results;

	for (let i = 0; i < resultsArray.length; i++) {
		if (resultsArray[i].uid == query) {
			resultsChosen.push(resultsArray[i]);
		}
	}

	if (query == 'all') {
		const metaTitle = data.results[0]?.data.meta_title[0]?.text;
		const metaDescription = data.results[0]?.data.meta_description[0]?.text;
		const metaTags = data.results[0]?.data.meta_keywords[0]?.text;

		return (
			<Helmet>
				<title>{metaTitle}</title>
				<meta charSet='utf-8' />
				<meta name='description' content={metaDescription} />
				<meta name='keywords' content={metaTags} />
				<script
					async
					defer
					src='https://static.cdn.prismic.io/prismic.js?new=true&repo=milligram'
				></script>
			</Helmet>
		);
	} else {
		const metaTitle = resultsChosen[0]?.data?.meta_title[0]?.text;
		const metaDescription = resultsChosen[0]?.data?.meta_description[0]?.text;
		const metaTags = resultsChosen[0]?.data?.meta_keywords[0]?.text;

		return (
			<>
				<Helmet>
					<title>{metaTitle}</title>
					<meta charSet='utf-8' />
					<meta name='description' content={metaDescription} />
					<meta name='keywords' content={metaTags} />
					<script
						async
						defer
						src='https://static.cdn.prismic.io/prismic.js?new=true&repo=milligram'
					></script>
				</Helmet>
			</>
		);
	}
};
